var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    viewBox: "0 0 14 14",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#eff4fb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.5858.585786c.781-.781048 2.0474-.781048 2.8284 0 .7811.781044.7811 2.047374 0 2.828424l-.7929.7929-2.82841-2.82843z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.37868 2.79289-8.37868 8.37871v2.8284h2.82842l8.37868-8.37868z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.4383f4ac8906ab35a09de3fba8db4bf7.svg";
export { ForwardRef as ReactComponent };